import { useState, useEffect } from 'react';

export interface TelegramUser {
  id: number;
  first_name: string;
  last_name?: string;
  username?: string;
}

interface UseTelegramReturn {
  telegramId: string | null;
  isLoading: boolean;
  user: TelegramUser | null;
}

export const useTelegram = (): UseTelegramReturn => {
  // For development, return a mock user state
  return {
    telegramId: "123456789", // Mock telegram ID
    isLoading: false,
    user: {
      id: 123456789,
      first_name: "Test",
      username: "test_user"
    }
  };
}; 